module.exports = "https://coursera_assets.s3.amazonaws.com/images/d9bffb66246f4e733d017228ecc0e206.png";